import { LandingLayout } from 'layouts';
import { useLocation } from 'react-router';
import { ContentLeft, Footer, ForgotPassword, Header, type HeaderItem } from 'features/onboarding';
import { useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type ForgotPasswordLocationState = { email?: string } & OnboardingLocationState;

const PageForgotPassword = () => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: ForgotPasswordLocationState | undefined = location.state;
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin, onNavigateToSignUp } = useOnboardingNavigation<ForgotPasswordLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <ForgotPassword
          email={state?.email}
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onResetSuccess={onNavigateToPrimaryLogin}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PageForgotPassword;
